import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGameShow = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.63 2.344a.75.75 0 0 0-1.26 0L8.166 7.32 2.573 8.682a.75.75 0 0 0-.38 1.23l3.975 4.422-.635 5.77a.75.75 0 0 0 1.05.768l2.453-1.09a.75.75 0 0 0-.609-1.371l-1.26.56.529-4.807a.75.75 0 0 0-.188-.584L4.147 9.842l4.666-1.136a.75.75 0 0 0 .453-.323L12 4.136l2.734 4.247a.75.75 0 0 0 .453.323l4.666 1.136-3.36 3.738a.75.75 0 0 0-.189.584l.529 4.807-1.26-.56a.75.75 0 1 0-.61 1.37l2.454 1.091a.75.75 0 0 0 1.05-.767l-.635-5.771 3.976-4.422a.75.75 0 0 0-.38-1.23l-5.595-1.363zM12 14.21h1.09a.75.75 0 0 1 0 1.5h-.34v4.79h1.43a.75.75 0 0 1 0 1.5H9.824a.75.75 0 0 1 0-1.5h1.427v-4.79h-.338a.75.75 0 0 1 0-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGameShow;
